const STATUS = {
  active: "Active",
  passive: "Passive",
  draft: "Draft",
};

const BOOL_OPTIONS = [
  { label: "common:yes", value: true },
  { label: "common:no", value: false },
];

const DATATABLE_PAGING = {
  pageSize: 15,
  pageIndex: 1,
};

const COMPANY_CATEGORY = {
  beverages: "Beverages",
  snacks: "Snacks",
};

const DATE_MASK = "DD/MM/YYYY";
const DATE_MASK_POINT = "DD.MM.YYYY";
const DATE_TIME_MASK = "DD/MM/YYYY - HH:mm:ss";
const DATE_TIME_MASK_POINT = "DD.MM.YYYY - HH:mm:ss";
const DATE_FORMAT = "YYYY-MM-DD";
const DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSSZ";
const TIME_FORMAT_BE = "0.HH:mm:ss:";
const TIME_MASK = "__:__:__";

const WEEK_DAYS = {
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
};

const DAYS = [
  { label: "common:days.monday", value: WEEK_DAYS.monday },
  { label: "common:days.tuesday", value: WEEK_DAYS.tuesday },
  { label: "common:days.wednesday", value: WEEK_DAYS.wednesday },
  { label: "common:days.thursday", value: WEEK_DAYS.thursday },
  { label: "common:days.friday", value: WEEK_DAYS.friday },
  { label: "common:days.saturday", value: WEEK_DAYS.saturday },
  { label: "common:days.sunday", value: WEEK_DAYS.sunday },
];

const ADMIN_RIGHTS = {
  opportunities: "Opportunities",
  dynamicQuota: "DynamicQuota",
  promoLoginAuthorization: "PromoLoginAuthorization",
  product: "Product",
  codePool: "CodePool",
  campaign: "Campaign",
  callCenter: "CallCenter",
  donationDefinition: "DonationDefinition",
  settings: "Settings",
  uploadGift: "UploadGift",
  survey: "Survey",
};

const FLAGS = {
  TURKEY: "/images/flags/tr-flag.png",
  UNITED_STATES: "/images/flags/us-flag.png",
  UNITED_KINGDOM: "/images/flags/en-flag.png",
  EUROPEAN_UNION: "/images/flags/euro-flag.png",
};

const CURRENCY_CODE_TO_FLAG_PATH: Record<string, string> = {
  TL: FLAGS.TURKEY,
  USD: FLAGS.UNITED_STATES,
  EUR: FLAGS.EUROPEAN_UNION,
  GBP: FLAGS.UNITED_KINGDOM,
};

const COUNTRY_CODE_TO_FLAG_PATH: Record<string, string> = {
  TUR: FLAGS.TURKEY,
  USA: FLAGS.UNITED_STATES,
  GBR: FLAGS.UNITED_KINGDOM,
};

const CURRENCY = {
  TRY: "TRY",
  USD: "USD",
  EUR: "EUR",
  GBP: "GBP",
};

export {
  STATUS,
  BOOL_OPTIONS,
  DATATABLE_PAGING,
  COMPANY_CATEGORY,
  DATE_MASK,
  DATE_MASK_POINT,
  DATE_TIME_MASK,
  DATE_TIME_MASK_POINT,
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  TIME_FORMAT_BE,
  TIME_MASK,
  WEEK_DAYS,
  DAYS,
  ADMIN_RIGHTS,
  CURRENCY_CODE_TO_FLAG_PATH,
  COUNTRY_CODE_TO_FLAG_PATH,
  CURRENCY,
};
